import SelectVacanciesModal from './SelectVacanciesModal.component';

export default SelectVacanciesModal;